import { render, staticRenderFns } from "./boxData.vue?vue&type=template&id=13b6151b"
import script from "./boxData.vue?vue&type=script&lang=js"
export * from "./boxData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports